import React from "react";
import * as Funciones from "../../../../utils/funciones";
import styles from "./texto-devolucion.module.css"

const TextoDevolucion = ({ montoDevolucion, moneda }) => {
    return (
        <div className={styles.contenedor}>
            <span className={styles.texto_titulo}>
                Devolución al finalizar el plazo de contratación
            </span>
            <span className={styles.texto_monto}>
                {Funciones.mostrarFormatoMoneda(montoDevolucion, moneda.codigo, false)}
            </span>
        </div>
    )
}

export default TextoDevolucion;